import {
  Box,
  Button,
  Modal,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit"; // Import the Edit icon
import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { t } from "i18next";

const Edit = ({
  id,
  address,
  name,
  description,
  latitude,
  longitude,
  type,
}) => {
  const [Editopen, setEditOpen] = useState(false);
  const [alignment, setAlignment] = useState(type);
  const [formValues, setFormValues] = useState({
    name: name,
    description: description,
    address: address,
    latitude: latitude,
    longitude: longitude,
  });

  const handleAlignment = (event, newAlignment) => {
    if (newAlignment != null) {
      setAlignment(newAlignment);
    }
  };

  const EditModalOpen = () => setEditOpen(true);
  const EditModalClose = () => setEditOpen(false);

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const refreshPage = () => {
    window.location.reload();
  };

  const EditData = (e) => {
    e.preventDefault();
    const { name, description, address, latitude, longitude } = e.target;

    const updatedAddress = {
      name: name.value,
      description: description.value,
      address: address.value,
      latitude: latitude.value,
      longitude: longitude.value,
    };

    // Assume an API call is placed here to update the address
    console.log("Updating address with:", updatedAddress);
    toast.success("Address Updated Successfully", {
      onClose: refreshPage,
    });

    EditModalClose();
  };

  return (
    <>
      <Button
        sx={{ mt: "10px" }}
        variant="text"
        onClick={EditModalOpen}
        startIcon={<EditIcon />}
      >
        {t("edit")}
      </Button>
      <Modal
        open={Editopen}
        onClose={EditModalClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          className="form-modal"
          sx={{
            padding: 2,
            backgroundColor: "white",
            borderRadius: 2,
            margin: 2,

          }}
        >
          <IconButton
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
            }}
            onClick={EditModalClose}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h5" component="h5" className="mb20">
            {t("Edit Location")}
          </Typography>

          <form onSubmit={EditData}>
            <TextField
              fullWidth
              label={t("name")}
              name="name"
              value={formValues.name}
              onChange={onInputChange}
              className="mb20 mt20"
            />
            <TextField
              fullWidth
              label={t("description")}
              name="description"
              value={formValues.description}
              onChange={onInputChange}
              className="mb20 mt20"
            />
            <TextField
              fullWidth
              label={t("address")}
              name="address"
              value={formValues.address}
              onChange={onInputChange}
              className="mb20 mt20"
            />
            <Box display="flex" gap={2} className="mb20 mt20">
              <TextField
                label={t("latitude")}
                name="latitude"
                value={formValues.latitude}
                onChange={onInputChange}
                fullWidth
              />
              <TextField
                label={t("longitude")}
                name="longitude"
                value={formValues.longitude}
                onChange={onInputChange}
                fullWidth
              />
            </Box>

            <ToggleButtonGroup
              value={alignment}
              color="error"
              exclusive
              onChange={handleAlignment}
              aria-label="address type"
              sx={{ marginBottom: "20px" }}
            >
              <ToggleButton value="home" onClick={handleAlignment}>
                {t("home")}
              </ToggleButton>
              <ToggleButton value="office" onClick={handleAlignment}>
                {t("office")}
              </ToggleButton>
              <ToggleButton value="other" onClick={handleAlignment}>
                {t("other")}
              </ToggleButton>
            </ToggleButtonGroup>

            <Button
              fullWidth
              variant="outlined"
              type="submit"
              color="primary"
              sx={{ marginTop: "20px" }}
            >
              {t("update")}
            </Button>
          </form>
        </Box>
      </Modal>
    </>
  );
};

export default Edit;
